import { useSetState } from '@domain-group/react-hooks'

import filterUnselectedEntities from '@functions/filterUnselectedEntities'

import useSelector from '@hooks/useSelector'
import useUser from '@hooks/useUser'

import { UserModel } from '@domain-group/realhub-backend-api-types'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import type { ModalCallbacks } from '../index'

type DefaultState = {
  newAgentId: null | number,
}

const defaultState: DefaultState = {
  newAgentId: null,
}

type DeleteAgentParams = {
  callbacks: ModalCallbacks,
  user: UserModel,
}

const useDeleteAgentModal = (params: DeleteAgentParams) => {
  const { callbacks: { closeModal }, user: initUser } = params

  const [state, setState] = useSetState(defaultState)
  const { newAgentId } = state

  const {
    callbacks: { transferCampaignsAndDeleteUser: transferFn },
    updating,
    user,
  } = useUser(initUser)

  const entities = useSelector(reduxState => reduxState.entities)
  const filteredUsers = filterUnselectedEntities({ entities, entityKey: 'users', entityIds: [user.id] })
  // @ts-expect-error TS18046
  const filteredAgents = filteredUsers.filter(user => user.actable_type === 'Agent')

  // To be used with handleCallbackAction
  const deleteAgentPayload: HandleCallbackActionParams = {
    callbacks: {
      // @ts-expect-error TS2322
      action: transferFn,
      afterAction: closeModal,
    },
    entityParams: { newAgentId },
    toastText: 'Agent Deleted',
    shouldRedirect: true,
  }

  const saveEnabled = !!newAgentId

  return {
    callbacks: {
      selectAgent: (id: number) => setState({ newAgentId: id }),
    },
    deleteAgentPayload,
    filteredAgents,
    newAgentId,
    saveEnabled,
    updating,
    user,
  }
}

export default useDeleteAgentModal
